// Where a player was before a live casino game took the whole page (iPhone,
// CasinoGameList): coming back, by Back or by an iPhone home-screen app
// reopening at its start page, puts them on the same list at the same height.
const KEY = 'tottalo.casinoReturn';
const MAX_AGE_MS = 30 * 60 * 1000;

export type CasinoReturn = { path: string; scrollY: number; at: number };

/** scrollY: where the list was when the game was tapped (the loading screen
 *  moves the page after). */
export function saveCasinoReturn(scrollY: number) {
  try {
    const r: CasinoReturn = {
      path: window.location.pathname + window.location.search,
      scrollY,
      at: Date.now(),
    };
    localStorage.setItem(KEY, JSON.stringify(r));
  } catch {
    // storage blocked: the player comes back to the start
  }
}

/** The saved place, once: it is cleared as it is read. */
export function takeCasinoReturn(): CasinoReturn | null {
  try {
    const raw = localStorage.getItem(KEY);
    localStorage.removeItem(KEY);
    if (!raw) return null;
    const r = JSON.parse(raw) as CasinoReturn;
    return Date.now() - r.at < MAX_AGE_MS ? r : null;
  } catch {
    return null;
  }
}
